import { useState } from "react";

export default function BType({ isSmall,isSmall2 }) {
  const [selected, setSelected] = useState([]);
  
    const handleClick = (value) => {
      if (selected.includes(value)) {
        setSelected(selected.filter((v) => v !== value)); // снимаем выбор при повторном клике
      } else {
        setSelected([...selected, value]); // выбираем новое значение
      }
  };
  const [isSmall1] = useState(window.innerWidth <= 900);
  const options = [
    { id: "bb1", label: isSmall1 ? "ՊԱՆ." : "ՊԱՆԵԼԱՅԻՆ", value: "Panel" },
    { id: "bb2", label: isSmall1 ? "ՔԱՐԵ" : "ՔԱՐԵ", value: "Stone" },
    { id: "bb3", label: isSmall1 ? "ՄՈՆ." : "ՄՈՆՈԼԻՏ", value: "Monolith" },
    { id: "bb4", label: isSmall1 ? "ԱՅԼ" : "ԱՅԼ", value: "Other" },
  ];
  const [opened, setOpened] = useState(false);
  return (
    <div
      className="bType"
      style={{
        borderRadius: "10px",
      }}
    >
      {isSmall2 && <h5 onClick={()=>setOpened(!opened)}>ՇԻՆ. ՏԻՊ</h5>}
      {isSmall2 && opened && (
        <div className="with openhidden">
          {options.map((type, i) => (
            <div key={i}>
              <input
                type="checkbox"
                name="building_type"
                id={type.id}
                value={type.value}
                onChange={() => handleClick(type.value)}
              />
              <label htmlFor={type.id}>{type.label}</label>
            </div>
          ))}
        </div>
      )}
      {isSmall2 && opened && (
        <div className="newbuilding">
          <input id='new_status' type="checkbox" name="new_status" />
          <label htmlFor='new_status'>
            {isSmall1 ? "ՆՈՐ." : isSmall ? "ՆՈՐԱԿԱՌ." : "ՆՈՐԱԿԱՌՈՒՅՑ"}
          </label>
        </div>
      )}

      {!isSmall2 && <h5>{isSmall ? "ՇԻՆ. ՏԻՊ" : "ՇԻՆՈՒԹՅԱՆ ՏԻՊ"}</h5>}
      {!isSmall2 && (
        <div className="with">
          {options.map((type, i) => (
            <div key={i}>
              <input
                type="checkbox"
                name="building_type"
                id={type.id}
                value={type.value}
                onChange={() => handleClick(type.value)}
              />
              <label htmlFor={type.id}>{type.label}</label>
            </div>
          ))}
        </div>
      )}
      {!isSmall2 && (
        <div className="newbuilding">
          <input id='new_status' type="checkbox" name="new_status" />
          <label htmlFor='new_status'>
            {isSmall1 ? "ՆՈՐ." : isSmall ? "ՆՈՐԱԿԱՌ." : "ՆՈՐԱԿԱՌՈՒՅՑ"}
          </label>
        </div>
      )}
    </div>
  );
}
